export default "__VITE_ASSET__D_68yE9A__"